var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-dialog",
    {
      staticClass: "new-bill-payment-dialog",
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("CargoMsg.Cargo_CreatePaymentRequestChooseFees"),
        width: "1100px",
        top: "5vh",
        "can-maximize": _vm.source === "append",
        "can-minimize": _vm.source === "append",
        source: _vm.source
      },
      on: { close: _vm.cancel }
    },
    [
      [
        !_vm.isQueryJob
          ? _c("native-query-charge", {
              ref: "queryCharge",
              attrs: {
                "show-simple": false,
                identify: "queryCharge",
                "view-source": "billPayment_Create_Charge",
                "has-bill-payment": 0,
                "charge-state-param": "BillPaymentChargeState",
                "confirm-state-param": "BillPaymentChargeConfirmState",
                "job-state-param": "BillPaymentJobState",
                "is-ar": _vm.defaultSearchConditions.isAr,
                "show-charge-count": _vm.showWindow,
                "check-verified-amount": true,
                "show-controlled-charge": false,
                "is-show-write-off": false,
                "new-by-job": 2,
                "internal-charge": _vm.defaultSearchConditions.internalCharge,
                "config-module": "5082",
                "grid-config-module": "508201"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "searchAreaHeader",
                    fn: function() {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Payment.inquiryWay")))
                        ]),
                        _c(
                          "el-radio-group",
                          {
                            attrs: { no: "1" },
                            on: { change: _vm.onQueryTypeChange },
                            model: {
                              value: _vm.queryType,
                              callback: function($$v) {
                                _vm.queryType = $$v
                              },
                              expression: "queryType"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { no: "2", label: "charge" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Payment.accordingToCharge"))
                                )
                              ]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { no: "3", label: "job" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Payment.accordingToBusiness"))
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: {
                              no: "4",
                              "true-label": -1,
                              "false-label": 0
                            },
                            model: {
                              value: _vm.defaultSearchConditions.isAr,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.defaultSearchConditions,
                                  "isAr",
                                  $$v
                                )
                              },
                              expression: "defaultSearchConditions.isAr"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Payment.includeReceivables")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.useOrderCenterMode,
                                expression: "useOrderCenterMode"
                              }
                            ],
                            attrs: { no: "5" },
                            model: {
                              value: _vm.defaultSearchConditions.internalCharge,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.defaultSearchConditions,
                                  "internalCharge",
                                  $$v
                                )
                              },
                              expression:
                                "defaultSearchConditions.internalCharge"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_InternalCharges"))
                            )
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#ff0000",
                              "margin-left": "10px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Payment.couldNotSearhWriteOffJobFromThisWindow"
                                )
                              )
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                3447745882
              )
            })
          : _vm._e(),
        _vm.isQueryJob
          ? _c("query-job-fast", {
              ref: "queryJob",
              attrs: {
                "show-simple": false,
                identify: "queryJob",
                "view-source": "billPayment_Create_Job",
                "total-data-field": "chargeAmount",
                "total-currency-field": "chargeCurrency",
                "charge-state-param": "BillPaymentChargeState",
                "confirm-state-param": "BillPaymentChargeConfirmState",
                "job-state-param": "BillPaymentJobState",
                "is-ar": _vm.defaultSearchConditions.isAr,
                "has-bill-payment": 0,
                "show-charge-count": _vm.showWindow,
                "show-controlled-charge": false,
                "new-by-job": 1,
                "internal-charge": _vm.defaultSearchConditions.internalCharge,
                "config-module": "5083",
                "grid-config-module": "508301"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "searchAreaHeader",
                    fn: function() {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Payment.inquiryWay")))
                        ]),
                        _c(
                          "el-radio-group",
                          {
                            attrs: { no: "6" },
                            on: { change: _vm.onQueryTypeChange },
                            model: {
                              value: _vm.queryType,
                              callback: function($$v) {
                                _vm.queryType = $$v
                              },
                              expression: "queryType"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { no: "7", label: "charge" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Payment.accordingToCharge"))
                                )
                              ]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { no: "8", label: "job" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Payment.accordingToBusiness"))
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: {
                              no: "9",
                              "true-label": -1,
                              "false-label": 0
                            },
                            model: {
                              value: _vm.defaultSearchConditions.isAr,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.defaultSearchConditions,
                                  "isAr",
                                  $$v
                                )
                              },
                              expression: "defaultSearchConditions.isAr"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Payment.includeReceivables")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.useOrderCenterMode,
                                expression: "useOrderCenterMode"
                              }
                            ],
                            attrs: { no: "10" },
                            model: {
                              value: _vm.defaultSearchConditions.internalCharge,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.defaultSearchConditions,
                                  "internalCharge",
                                  $$v
                                )
                              },
                              expression:
                                "defaultSearchConditions.internalCharge"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_InternalCharges"))
                            )
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#ff0000",
                              "margin-left": "10px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Payment.couldNotSearhWriteOffJobFromThisWindow"
                                )
                              )
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2431550218
              )
            })
          : _vm._e()
      ],
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "11", type: "primary", size: "mini" },
              on: { click: _vm.nextStep }
            },
            [_vm._v(_vm._s(_vm.$t("Payment.next")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "12", size: "mini" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("Payment.cancel")))]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }